// export const baseUrl = `https://shrouded-springs-36139.herokuapp.com`;
// export const baseUrl = `https://apric-cms.herokuapp.com`;
// export const baseUrl = `https://api.apric.in`;
// export const baseUrl = `http://localhost:8000`;
export const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
